// @flow

import React from 'react';
import {
    IntlShape, injectIntl,
} from 'react-intl';
import { Route } from 'react-router';
import MapsPage from 'esm-web-pro/containers/pages/maps/MapsPage';


type Props = {
    intl: IntlShape,
}

const MapsRoutes = (addressesProps: Props) => {
    const { intl: { formatMessage } } = addressesProps;
    return (
        <>
            <Route
                path="/administration/maps/maps"
                component={MapsPage}
            />
        </>
    );
};

export default injectIntl(MapsRoutes);
